import { CircularProgress, ComponentAlignment } from '@makyoapp/makyo-tw-ui'

import { SpacingInputValue } from '@/shared/builder'

import { LayoutDemo } from './LayoutDemo'

export const CircleProgressDemo = () => {
  return (
    <LayoutDemo title='Circular Progress' bgColor='var(--color-primary-90)'>
      <div className='w-full h-full p-14'>
        <CircularProgress
          width={'70%'}
          margin={'0' as unknown as SpacingInputValue}
          alignment={'center' as ComponentAlignment}
          trackColor={`var(--color-primary-50)`}
          fillColor={`var(--color-primary-80)`}
          textColor={`var(--color-on-primary-90)`}
          progress={0.25}
          withLabel={true}
          thickness={12}
          typography={{ typography: 'Heading Medium' }}
        />
      </div>
    </LayoutDemo>
  )
}
